import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'Components/Form'
import SvgIcon from 'Components/SvgIcon'
import {
  _RecipientInput,
  _CloseContainer,
  _AddBtn,
} from './styles'

export const emailErrorMsg = 'Email is Invalid'
// eslint-disable-next-line
const emailValidate = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/

const RecipientInput = ({ index, value, onAdd, onDelete, showDelete }) => {
  const [error, updateError] = useState('')
  const [inputVal, onChange] = useState(value)

  function onInputChange(e) {
    onChange(e.value)
  }
  function onDeleteClick() {
    onDelete(index)
  }
  function addRecipient() {
    const match = inputVal.match(emailValidate)
    if(match) {
      onAdd(index, inputVal)
      updateError('')
    } else {
      updateError('Email is Invalid')
    }
  }
  function onBlur() {
    if(inputVal) {
      addRecipient()
    } else {
      const onlyUpdateLocal = true
      onDelete(index, onlyUpdateLocal)
    }
  }

  return (
    <_RecipientInput data-test-id="recipientInput">
      <Input
        data-test-id="inputComponent"
        name={'ccEmail' + index}
        value={inputVal}
        onChange={onInputChange}
        placeholder={'Enter CC email'}
        errorText={error}
        onBlur={onBlur}
        disabled={showDelete}
        focusOnMount
        withNewStyle
      />
      {
        showDelete ? (
          <_CloseContainer data-test-id="closeIcon" onClick={onDeleteClick}>
            <SvgIcon
              name={'#icon-close'}
              width={12}
              height={12}
            />
          </_CloseContainer>
        ) : (
          <_AddBtn
            data-test-id="addBtn"
            onClick={addRecipient}
          >
            Add
          </_AddBtn>
        )
      }
    </_RecipientInput>
  )
}

RecipientInput.propTypes = {
  index: PropTypes.number,
  value: PropTypes.string,
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  showDelete: PropTypes.bool,
}

export default RecipientInput
